import { useState } from "react";
import { Button, Input, Message } from "semantic-ui-react";
import { fmtDateTime } from "../adminHelpers";
import { formatRupees, isMoney } from "../../../utils/money";

/* "Room 508 checked out 2 days early — charge retention?" One question per
   room that left before its booked last day. The bill cannot be finalized
   until each is answered. */
export default function BillRetention({ bill, editable, busy, onDecide }) {
  if (!bill.earlyCheckouts.length) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {bill.earlyCheckouts.map((e) => (
        <RetentionQuestion key={e.assignmentId} entry={e} editable={editable} busy={busy} onDecide={onDecide} />
      ))}
    </div>
  );
}

function RetentionQuestion({ entry, editable, busy, onDecide }) {
  const [reopened, setReopened] = useState(false);
  const [amount, setAmount] = useState(String(Number(entry.suggestedAmount)));
  const asking = !entry.decided || reopened;
  const decide = async (apply) => {
    if (await onDecide({ assignment_id: entry.assignmentId, apply, amount: apply ? amount.trim() : undefined })) {
      setReopened(false);
    }
  };

  const facts = (
    <>
      <strong>{entry.room}</strong> checked out <strong>{entry.daysSaved} day(s) early</strong> — left{" "}
      {fmtDateTime(entry.checkedOut)}, booked until {fmtDateTime(entry.bookedUntil)}.
    </>
  );

  if (!asking) {
    return (
      <Message size="small" info>
        {facts}{" "}
        {entry.applied ? <>Retention charged: <strong>{formatRupees(entry.amount)}</strong>.</> : <>No retention charged.</>}
        {editable && (
          <Button size="mini" basic compact style={{ marginLeft: 8 }} onClick={() => setReopened(true)}>Change answer</Button>
        )}
      </Message>
    );
  }
  return (
    <Message size="small" warning>
      <div style={{ marginBottom: 6 }}>{facts} Charge a retention amount?</div>
      {editable ? (
        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
          <span>Amount before GST ₹</span>
          <Input size="small" style={{ width: 110 }} value={amount} error={!isMoney(amount)}
            aria-label={`Retention amount for ${entry.room}`} onChange={(_, d) => setAmount(d.value)} />
          <Button size="small" color="orange" disabled={busy || !isMoney(amount) || Number(amount) <= 0}
            onClick={() => decide(true)}>Yes, charge</Button>
          <Button size="small" basic disabled={busy} onClick={() => decide(false)}>No charge</Button>
          {reopened && <Button size="small" basic compact onClick={() => setReopened(false)}>Cancel</Button>}
          <span style={{ fontSize: "0.85em", opacity: 0.7 }}>
            Suggested: {formatRupees(entry.suggestedAmount)}, from the guest house's retention setting
          </span>
        </div>
      ) : (
        <div>Waiting for an admin to answer.</div>
      )}
    </Message>
  );
}
